import type {
  StrategyChartColors,
  StrategyChartKind,
  StrategyChartTimeframe,
} from './strategySymbolChartData';

export interface StrategyChartLegendEntry {
  label: string;
  color: string;
}

export interface StrategyChartLegendStatus {
  entry_sma_period?: number | null;
  sma_period?: number | null;
}

export const strategyChartLegend = (
  strategy: StrategyChartKind,
  timeframe: StrategyChartTimeframe,
  status: StrategyChartLegendStatus | undefined,
  colors: StrategyChartColors,
): StrategyChartLegendEntry[] => {
  if (strategy === 'MORB' && timeframe === '1d') {
    return [
      { label: `${status?.entry_sma_period || 50} SMA`, color: colors.warning },
      { label: `${status?.sma_period || 10} SMA`, color: colors.warningBright },
      { label: 'Buy / close signals', color: colors.neon },
    ];
  }
  if (strategy === 'MORB') {
    return [
      { label: 'Market open', color: colors.info },
      { label: 'ORB high / low', color: colors.success },
      { label: 'ATR entry trigger', color: colors.warningBright },
    ];
  }
  if (strategy === 'ORB') {
    return [
      { label: 'Open range', color: colors.success },
      { label: 'Live support/resistance', color: colors.neon },
    ];
  }
  if (strategy === 'DT') {
    return [
      { label: 'Daily open', color: colors.info },
      { label: 'ATR thresholds', color: colors.success },
    ];
  }
  return [
    { label: 'SMA 30', color: colors.success },
    { label: 'SMA 200', color: colors.warningBright },
  ];
};
